export default __webpack_public_path__ + "static/media/Blu_Background-01.6e93eb94.png";